import NavigationBar from './components/navigationBar/navigationBar';
import Footer from './components/footer/footer';
import Home from './pages/home/home';
import Contact from './pages/contact/contact';
import Mission from './pages/mission/mission';
import Sponsors from './pages/sponsors/sponsors';
import Bylaws from './pages/by-laws/by-laws';
import BoardDirectory from './pages/board-directory/board-directory';
import Schedule from './pages/schedule/schedule';
import MembershipDocument from './pages/membership-document/membership-document';
import NotFoundError from './pages/404-error/404-error';
import { Routes, Route, useLocation } from 'react-router-dom';
import './app.scss';

function PageRoutes() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/mission" element={<Mission />} />
      <Route path="/sponsors" element={<Sponsors />} />
      <Route path="/by-laws" element={<Bylaws />} />
      <Route path="/board-directory" element={<BoardDirectory />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/membership-document" element={<MembershipDocument />} />
      <Route path="*" element={<NotFoundError />} />
    </Routes>
  );
}

function App() {
  const { pathname } = useLocation();

  return (
    <div className="App">
      <NavigationBar />
      <div className="page-viewport" key={pathname}>
        <div className="content">
          <PageRoutes />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
